import { useEffect, useMemo, useState } from 'react';

import { MS_PER_HOUR } from '../../constants';
import { getLastNMonthOptionsUTC } from '../../utils';

export function useUsageMonthOptions() {
  const [utcHourKey, setUtcHourKey] = useState(() => Math.floor(Date.now() / MS_PER_HOUR));
  useEffect(() => {
    const id = window.setInterval(() => {
      setUtcHourKey(Math.floor(Date.now() / MS_PER_HOUR));
    }, MS_PER_HOUR);
    return () => window.clearInterval(id);
  }, []);
  const today = useMemo(() => new Date(utcHourKey * MS_PER_HOUR), [utcHourKey]);
  const monthOptions = useMemo(() => getLastNMonthOptionsUTC({ today }), [today]);
  const defaultMonth = monthOptions[0].key;

  return { today, monthOptions, defaultMonth };
}
